if (typeof AFRAME === 'undefined') {
  throw new Error('Component attempted to register before AFRAME was available.');
}

AFRAME.registerComponent('checkpointspot', {
  schema: {
    radius: { type: 'number', default: 0.45 },
    color: { type: 'string', default: '#2d283d' },
    texture: { type: 'string', default: '#centertexture' },
    rayobj: { type: 'string', default: '' },
  },

  init: function() {
    var data = this.data;
    var el = this.el;

    el.setAttribute('geometry', `primitive: circle; radius: ${data.radius};`);
    el.setAttribute('material', `opacity:0.45; color:${data.color}; src:${data.texture};`);
    el.setAttribute('rotation', '-90 0 0');
    el.setAttribute('position', '0 0.1 0');
    if(data.rayobj){
      el.setAttribute('class', data.rayobj);
    }

    var ring = document.createElement("a-entity");
    ring.setAttribute('geometry', `primitive:ring; radiusInner:0.3; radiusOuter:0.4;`);
    ring.setAttribute('material', `shader:flat; color:#fff; src:${data.texture};`);
    ring.setAttribute('position', '0 0 0.05');
    ring.setAttribute('animation__in', `property: geometry.radiusInner; to: 0.5; delay: 0; dur: 500; easing: easeInOutSine; startEvents: in; autoplay: false`),
    ring.setAttribute('animation__in2', `property: geometry.radiusOuter; to: 0.55; delay: 0; dur: 500; easing: easeInOutSine; startEvents: in; autoplay: false`),
    ring.setAttribute('animation__in3', `property: position; to: 0 0 0; delay: 0; dur: 500; easing: easeInOutSine; startEvents: in; autoplay: false`),
    ring.setAttribute('animation__out', `property: geometry.radiusInner; to: 0.3; delay: 0; dur: 200; easing: easeInOutSine; startEvents: out; autoplay: false`),
    ring.setAttribute('animation__out2', `property: geometry.radiusOuter; to: 0.4; delay: 0; dur: 200; easing: easeInOutSine; startEvents: out; autoplay: false`),
    ring.setAttribute('animation__out3', `property: position; to: 0 0 0.05; delay: 0; dur: 200; easing: easeInOutSine; startEvents: out; autoplay: false`),
    el.appendChild(ring);

    el.addEventListener('mouseenter', function () {
      ring.emit('in');
    });

    el.addEventListener('mouseleave', function () {
      ring.emit('out');
    });

  },
  play: function () {
  },
  update: function (oldData) {
  },
});

/*
  <a-animation begin="mouseenter" attribute="geometry.radiusInner" from="0.1" to="0.3" dur="500"></a-animation>
  <a-animation begin="mouseout" attribute="geometry.radiusInner" from="0.3" to="0.1" dur="200"></a-animation>
*/


// WEBPACK FOOTER //
// ./src/aframe/components/checkpointspot.js